<template>
    <div v-if="currentPost">
        <section class="clearfix">
            <h2 class="blog-title">{{ currentPost.title }}</h2>

            <div class="blog-header">
                <div class="blog-date">{{ currentPost.date }}</div>
                <button @click="goToNextPost" :class="{disabled: !hasNext}">&gt;</button>
                <button @click="goToPreviousPost" :class="{disabled: !hasPrev}">&lt;</button>
            </div>

            <div class="blog-post-and-nav clearfix">
                <BlogPost :post="currentPost" />
                <BlogNav
                    :blog-index="index"
                    :current-post-id="currentPostId"
                    @change-post="changePost"
                />
            </div>

            <div class="blog-footer">
                <button @click="goToNextPost" :class="{disabled: !hasNext}">&gt;</button>
                <button @click="goToPreviousPost" :class="{disabled: !hasPrev}">&lt;</button>
            </div>

        </section>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import BlogPost from '@/components/BlogPost.vue';
import BlogNav from '@/components/BlogNav';

export default {
    components: {
        BlogNav,
        BlogPost,
    },
    created() {
        this.initData(window.location.pathname.substr(1));
        window.onpopstate = (e) => {
            if (e.state?.postId) {
                this.goToPost({ postId: e.state.postId, putOnHistory: false });
            }
        };
    },
    computed: {
        ...mapState([
            'currentPost',
            'currentPostId',
            'latestPostId',
            'index',
        ]),
        hasPrev() {
            return this.currentPostId > 1;
        },
        hasNext() {
            return this.currentPostId < this.latestPostId;
        },
    },
    watch: {
        currentPost(post) {
            if (post) {
                document.title = post.title;
            }
        },
    },
    methods: {
        ...mapActions({
            initData: 'init',
            goToPost: 'goToPost',
        }),
        goToPreviousPost() {
            this.changePost(this.currentPostId - 1);
        },
        goToNextPost() {
            this.changePost(this.currentPostId + 1);
        },
        changePost(id) {
            this.goToPost({ postId: id, putOnHistory: true });
        },
    },
}
</script>

<style>
.blog-title {
    position: relative;
}
.blog-header {
    margin-bottom: 20px;
}
.blog-footer {
    margin-top: 20px;
}
.blog-header,
.blog-footer {
    background-color: #333333;
    padding: 0 20px;
    height: 40px;
}
.blog-header > *,
.blog-footer > *,
.blog-footer > * > * {
    height: 40px;
    line-height: 40px;
    vertical-align: middle;
}
.blog-footer {
    padding-left: 0;
}
.blog-date {
    display: inline-block;
    color: #FFFFFF;
}
.blog-header > button,
.blog-footer > button {
    display: block;
    cursor: pointer;
    float: right;
    padding: 0 20px;
    color: #FFFFFF;
}
.blog-header > button.disabled,
.blog-footer > button.disabled {
    cursor: default;
    color: #999999;
}

.blog-post-and-nav {
    width: 100%;
}
</style>
